function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.78 4.625a1 1 0 10-1.56-1.25l-3 4a1 1 0 000 1.25l3 4a1 1 0 101.56-1.25L7.28 8l2.5-3.375z"
});

function SvgChevronLeft16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNzgwODcgNC42MjQ3M0MxMC4xMjU5IDQuMTkzNDcgMTAuMDU2IDMuNTY0MTggOS42MjQ2OSAzLjIxOTE3QzkuMTkzNDMgMi44NzQxNiA4LjU2NDE0IDIuOTQ0MDggOC4yMTkxMyAzLjM3NTM0TDUuMjE5MTMgNy4zNzUzNEM0LjkyNjk2IDcuNzQwNTYgNC45MjY5NiA4LjI1OTUxIDUuMjE5MTMgOC42MjQ3M0w4LjIxOTEzIDEyLjYyNDdDOC41NjQxNCAxMy4wNTYgOS4xOTM0MyAxMy4xMjU5IDkuNjI0NjkgMTIuNzgwOUMxMC4wNTYgMTIuNDM1OSAxMC4xMjU5IDExLjgwNjYgOS43ODA4NyAxMS4zNzUzTDcuMjgwNjIgOC4wMDAwNEw5Ljc4MDg3IDQuNjI0NzNaIiAvPgo8L3N2Zz4K";
export { SvgChevronLeft16 as ReactComponent };